<script>
  import conciliacaoProjetoServico from '../servico';
  import moment from 'moment';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  const DIAS_ALERTA_VIGENCIA = 60;

  import DatePicker from 'vue2-datepicker';
  import ConfiguracaoProjetoModal from './ConfiguracaoProjetoModal.vue';
  import permissoesConciliacao from '~js/permissoes-conciliacao';

  export default {
    components: { DatePicker, ConfiguracaoProjetoModal },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        registros: [],
        resumo: this.resumoVazio(),
        listaProjetos: [],
        projetosStatus: [],
        ultimaAtualizacao: '',
        listaResponsaveis: [],
        possuiRestricaoResponsavel: false,
        todos: false,
        carregando: true,
        animated: true,
        filtros: this.carregarFiltros(),
        timerFiltro: null,
        mostrarConfiguracao: false,
        mostrarProcessamento: false,
        carregandoPrevia: false,
        processando: false,
        paresDesfeitosProcesso: [],
        previa: { pendentes: 0, incremental: false, restrito: false, dataCorte: '' },
        processados: 0,
        lancamentosLidos: 0,
        reprocessarTudo: false,
        exportando: false,
        dataReferenciaTesouraria: '',
      }
    },
    computed: {
      podeAlterar() { return permissoesConciliacao.alterar('projeto'); },
      podeConfigurar() { return permissoesConciliacao.configurar('projeto'); },
      indice() { return (this.resumo.indiceConciliacao || 0).toString().replace('.', ','); },
      pctConciliadas() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.conciliadas / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctNaoConciliadas() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.naoConciliadas / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctEmConciliacao() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.emConciliacao / this.resumo.totalConciliacoes * 100) : 0;
      },
      paginas() {
        const total = this.totalPaginas || 1;
        const atual = this.pagina || 1;
        const ini = Math.max(1, Math.min(atual - 2, total - 4));
        const fim = Math.min(total, ini + 4);
        const lista = [];
        for (let p = ini; p <= fim; p++) lista.push(p);
        return lista;
      },
      infoPaginacao() {
        const total = this.totalRegistros || 0;
        if (!total) return '';
        const por = this.registrosPorPagina || total;
        const ini = (this.pagina - 1) * por + 1;
        const fim = Math.min(total, ini + por - 1);
        return ini + '–' + fim + ' de ' + total + (total === 1 ? ' projeto' : ' projetos');
      },
      pendentes() { return Math.max(0, (this.resumo.totalConciliacoes || 0) - (this.resumo.conciliadas || 0)); },
      temFiltro() {
        return this.filtros.status !== '0' || this.filtros.situacaoProjeto !== '0' || !!this.filtros.idResponsavel
            || !!this.filtros.vigenciaDe || !!this.filtros.vigenciaAte || !!this.filtros.idProjeto || this.filtros.situacaoVigencia !== '0';
      },
      classeSituacaoVigencia() {
        if (this.filtros.situacaoProjeto === '1') return 'vig-neutro';
        return { '1': 'vig-ok', '2': 'vig-perto', '3': 'vig-vencida' }[this.filtros.situacaoVigencia] || 'vig-todas';
      },
      projetosOpcoes() {
        if (this.filtros.status === '0') return this.listaProjetos;
        return this.listaProjetos.filter(p => p.idProjetoCript === this.filtros.idProjeto || this.projetosStatus.indexOf(p.nomeProjeto) >= 0);
      },
      chipsRecorte() {
        const f = this.filtros;
        const chips = [];
        const data = d => moment(d).format('DD/MM/YYYY');
        const status = { '1': ['Conciliados', 'rec-ok'], '3': ['Em conciliação', 'rec-andamento'], '2': ['Não conciliados', 'rec-nunca'] }[f.status];
        if (status) chips.push({ chave: 'status', rotulo: status[0], classe: status[1], remover: () => this.filtrarStatus('0') });
        if (f.idProjeto) chips.push({ chave: 'projeto', rotulo: f.nomeProjeto || 'Projeto selecionado', icone: 'fa-folder-open-o', remover: () => { f.idProjeto = ''; f.nomeProjeto = ''; } });
        if (f.situacaoProjeto !== '0') chips.push({ chave: 'situacao', rotulo: f.situacaoProjeto === '1' ? 'Encerrados' : 'Ativos + encerrados', remover: () => { f.situacaoProjeto = '0'; } });
        if (f.idResponsavel) {
          const resp = this.listaResponsaveis.filter(r => String(r.idUsuario) === String(f.idResponsavel))[0];
          chips.push({ chave: 'responsavel', rotulo: resp ? resp.nomeUsuario : 'Responsável', icone: 'fa-user-o', remover: () => { f.idResponsavel = ''; } });
        }
        if (f.situacaoVigencia !== '0' && f.situacaoProjeto !== '1') {
          const vig = { '1': 'Dentro da vigência', '2': 'Termina em até 60 dias', '3': 'Vigência vencida' }[f.situacaoVigencia];
          chips.push({ chave: 'situacaoVigencia', rotulo: vig, icone: 'fa-circle', cor: { '1': '#18a689', '2': '#f0ad4e', '3': '#ed5565' }[f.situacaoVigencia], remover: () => { f.situacaoVigencia = '0'; } });
        }
        if (f.vigenciaDe || f.vigenciaAte) {
          const rotulo = f.vigenciaDe && f.vigenciaAte ? data(f.vigenciaDe) + ' a ' + data(f.vigenciaAte) : f.vigenciaDe ? 'a partir de ' + data(f.vigenciaDe) : 'até ' + data(f.vigenciaAte);
          chips.push({ chave: 'vigencia', rotulo: 'Vigência ' + rotulo, icone: 'fa-calendar-o', remover: () => { f.vigenciaDe = null; f.vigenciaAte = null; } });
        }
        return chips;
      },
      tituloSituacao() {
        if (this.filtros.situacaoProjeto === '1') return 'Projetos encerrados';
        if (this.filtros.situacaoProjeto === '2') return 'Ativos e encerrados';
        return 'Projetos ativos';
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Lista de Conciliação';

      const _this = this;
      $('#projetoFiltro').select2({ theme: 'bootstrap', placeholder: '🔍  Digite para buscar um projeto...', allowClear: true, language: 'pt-BR', minimumInputLength: 0 })
        .change(function () {
          _this.$set(_this.filtros, 'idProjeto', this.value || '');
          const projeto = _this.listaProjetos.filter(p => p.idProjetoCript === this.value)[0];
          _this.$set(_this.filtros, 'nomeProjeto', projeto ? projeto.nomeProjeto : '');
        });

      $('#situacaoVigenciaFiltro').select2({
        theme: 'bootstrap', language: 'pt-BR', minimumResultsForSearch: -1,
        templateResult: op => this.opcaoSituacaoVigencia(op, { '0': 'vig-todas', '1': 'vig-ok', '2': 'vig-perto', '3': 'vig-vencida' }[op.id]),
        templateSelection: op => this.opcaoSituacaoVigencia(op, this.classeSituacaoVigencia)
      }).change(function () {
        _this.$set(_this.filtros, 'situacaoVigencia', this.value || '0');
      });
      this.sincronizarSelectSituacaoVigencia();

      this.carregarProjetos();

      this.carregarResponsaveis();
    },
    methods: {
      resumoVazio() { return { totalConciliacoes: 0, conciliadas: 0, emConciliacao: 0, naoConciliadas: 0, indiceConciliacao: 0 }; },
      camposFiltros() { return { status: '0', situacaoProjeto: '0', idResponsavel: '', vigenciaDe: null, vigenciaAte: null, situacaoVigencia: '0', idProjeto: '', nomeProjeto: '', buscaProjeto: '' }; },
      filtrarStatus(status) { this.$set(this.filtros, 'status', this.filtros.status === status && status !== '0' ? '0' : status); },
      carregarFiltros() {
        try {
          const s = sessionStorage.getItem('conc-projeto-filtros');
          if (!s) return this.camposFiltros();
          const f = Object.assign(this.camposFiltros(), JSON.parse(s));
          if (f.vigenciaDe) f.vigenciaDe = new Date(f.vigenciaDe);
          if (f.vigenciaAte) f.vigenciaAte = new Date(f.vigenciaAte);
          return f;
        } catch (e) { return this.camposFiltros(); }
      },
      salvarFiltros() {
        try { sessionStorage.setItem('conc-projeto-filtros', JSON.stringify(this.filtros)); } catch (e) { }
      },
      montarFiltros() {
        return {
          status: this.filtros.status,
          situacaoProjeto: this.filtros.situacaoProjeto,
          idResponsavel: this.filtros.idResponsavel || 0,
          vigenciaDe: this.filtros.vigenciaDe ? moment(this.filtros.vigenciaDe).format('YYYY-MM-DD') : '',
          vigenciaAte: this.filtros.vigenciaAte ? moment(this.filtros.vigenciaAte).format('YYYY-MM-DD') : '',
          situacaoVigencia: this.filtros.situacaoProjeto === '1' ? '0' : this.filtros.situacaoVigencia,
          idProjeto: this.filtros.idProjeto || '',
          buscaProjeto: this.filtros.buscaProjeto || '',
        };
      },
      carregarProjetos() {
        return conciliacaoProjetoServico.projetos(this.todos, this.filtros.situacaoProjeto).then(p => { this.listaProjetos = p; });
      },
      sincronizarSelectProjeto() {
        const el = $('#projetoFiltro');
        if (!el.length) return;

        this.recuperarProjetoSalvo();

        el.val(this.filtros.idProjeto || '').trigger('change.select2');
      },
      opcaoSituacaoVigencia(op, classe) {
        if (op.id === undefined || op.id === '') return op.text;
        return $('<span class="sit-vig-op"></span>')
          .append($('<span></span>').addClass('sit-vig-dot sit-' + classe))
          .append(document.createTextNode(op.text));
      },
      sincronizarSelectSituacaoVigencia() {
        const el = $('#situacaoVigenciaFiltro');
        if (!el.length || !el.data('select2')) return;

        el.prop('disabled', this.filtros.situacaoProjeto === '1')
          .val(this.filtros.situacaoVigencia || '0').trigger('change.select2');
        el.next('.select2').find('.select2-selection__rendered').removeAttr('title');
      },
      recuperarProjetoSalvo() {
        const valor = this.filtros.idProjeto || '';
        if (!valor || this.listaProjetos.length === 0) return;
        if (this.listaProjetos.some(p => p.idProjetoCript === valor)) return;

        const projeto = this.listaProjetos.filter(p => p.nomeProjeto === this.filtros.nomeProjeto)[0];

        this.$set(this.filtros, 'idProjeto', projeto ? projeto.idProjetoCript : '');
        if (!projeto) this.$set(this.filtros, 'nomeProjeto', '');
      },
      carregarResponsaveis() {
        return conciliacaoProjetoServico.responsaveis()
          .then(r => { this.listaResponsaveis = r || []; })
          .catch(() => { this.listaResponsaveis = []; });
      },
      lista(pagina = 1) {
        this.carregando = true;
        this.registros = [];
        this.pagina = pagina;
        return conciliacaoProjetoServico.lista(pagina, this.montarFiltros(), this.todos)
          .then(dados => {
            this.carregando = false;
            this.registros = (dados.registros || []).slice().sort((a, b) => this.pendencias(b) - this.pendencias(a));
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;
            this.resumo = dados.resumo || this.resumoVazio();
            this.dataReferenciaTesouraria = dados.dataReferenciaTesourariaCurta || '';
            this.possuiRestricaoResponsavel = dados.possuiRestricaoResponsavel;
            this.projetosStatus = dados.projetosStatus || [];
            this.ultimaAtualizacao = moment().format('HH:mm');
          })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar as conciliações.'); });
      },
      atualizar() {
        if (this.carregando) return;
        this.carregarProjetos();
        this.lista(this.pagina);
      },
      agendarLista() {
        clearTimeout(this.timerFiltro);
        this.timerFiltro = setTimeout(() => this.lista(1), 250);
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => this.sincronizarSelectProjeto());
        this.carregarProjetos();
        this.agendarLista();
      },
      alternarTodos() { this.todos = !this.todos; this.carregarProjetos(); this.limparFiltros(); },
      irPagina(p) {
        if (p < 1 || p > this.totalPaginas || p === this.pagina) return;
        this.lista(p).then(() => this.$nextTick(() => { if (this.$refs.corpo) this.$refs.corpo.scrollTop = 0; }));
      },
      abrirConciliacao(projeto) {
        this.$router.push({ name: 'conciliacao-projeto.tela', params: { idProjetoCript: projeto.idProjetoCript } });
      },
      moeda(v) {
        const n = v || 0;
        const texto = Math.abs(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return (n < -0.004 ? '−R$ ' : 'R$ ') + texto;
      },
      moedaSinal(v) {
        const n = v || 0;
        return (n > 0.004 ? '+' : '') + this.moeda(n);
      },
      temBanco(t) { return !!t && t.saldoBanco !== null && t.saldoBanco !== undefined && t.dataSaldoBanco > 0; },
      tituloSemSaldo(r) {
        if (!r.idContaPadrao) return 'Projeto sem conta padrão';
        if (r.contaPadraoTransitoria) return 'Conta padrão transitória não entra na Posição de Tesouraria';
        return 'Conta padrão fora da Posição de Tesouraria';
      },
      textoPendencias(t) {
        const partes = [];
        if (t.lancamentosPorConciliar) partes.push(t.lancamentosPorConciliar + (t.lancamentosPorConciliar === 1 ? ' lançamento não conferido' : ' lançamentos não conferidos'));
        if (t.extratosPorConciliar) partes.push(t.extratosPorConciliar + (t.extratosPorConciliar === 1 ? ' linha de extrato' : ' linhas de extrato') + ' por conciliar');
        if (!partes.length && t.extratosPendentes) partes.push(t.extratosPendentes + ' linha(s) de extrato com lançamento ainda não conferido');
        return partes.join(' e ');
      },
      tituloSaldoTesouraria() {
        return 'Saldo da conta padrão do projeto: lançamentos conferidos (conciliados) no Manager até o fim de ' + (this.dataReferenciaTesouraria || 'D-1') + ', pela data do lançamento (mesmo cálculo da Lista de Banco e da Posição de Tesouraria)';
      },
      tituloOperacao(t) {
        const partes = ['Saldo por operação (todos os lançamentos, conferidos ou não): ' + this.moeda(t.saldoOperacao)];
        partes.push('Conciliado: ' + this.moeda(t.saldoConciliado));
        partes.push('Diferença: ' + this.moedaSinal(t.diferencaOperacao));
        if (t.lancamentosNaoConferidos) partes.push(t.lancamentosNaoConferidos + (t.lancamentosNaoConferidos === 1 ? ' lançamento não conferido' : ' lançamentos não conferidos') + ' desde a data de corte');
        return partes.join('\n');
      },
      tituloDivergencia(t) {
        if (t.conciliacaoPendente) return 'Conciliação pendente: ' + this.textoPendencias(t);
        const textos = {
          'baixa pendente': 'Conta conciliada, mas há borderô com arquivo enviado e títulos sem baixa',
          'estrutural': 'Conta conciliada e ainda assim diferente do banco: diferença a investigar',
        };
        return textos[t.tipoDivergencia] || '';
      },
      iconeDivergencia(t) {
        if (t.conciliacaoPendente) return 'fa-hourglass-half';
        return t.tipoDivergencia === 'baixa pendente' ? 'fa-clock-o' : 'fa-exclamation-triangle';
      },
      corDivergencia(t) {
        if (t.conciliacaoPendente) return 'div-laranja';
        return t.tipoDivergencia === 'baixa pendente' ? 'div-roxo' : 'div-vermelho';
      },
      abrirProcessamento() {
        this.mostrarProcessamento = true;
        this.processados = 0;
        this.lancamentosLidos = 0;
        this.paresDesfeitosProcesso = [];
        this.reprocessarTudo = false;
        this.carregarPrevia();
      },
      carregarPrevia() {
        this.carregandoPrevia = true;
        this.previa = { pendentes: 0, incremental: false, restrito: false, dataCorte: '' };
        conciliacaoProjetoServico.previaProcessamento(this.reprocessarTudo, this.todos)
          .then(dados => { this.previa = dados || this.previa; this.carregandoPrevia = false; })
          .catch(() => { this.carregandoPrevia = false; toastr.error('Não foi possível carregar os dados do processamento.'); });
      },
      alternarReprocessar() {
        if (this.processando) return;
        this.reprocessarTudo = !this.reprocessarTudo;
        this.carregarPrevia();
      },
      fecharProcessamento() {
        if (this.processando) return;
        this.mostrarProcessamento = false;
      },
      dataCorteTexto() {
        if (!this.previa.dataCorte) return 'sem data de corte — entra todo o histórico';
        return 'a partir de ' + moment(this.previa.dataCorte, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      processarProjetos() {
        if (this.processando) return;
        this.processando = true;
        this.processados = 0;
        this.lancamentosLidos = 0;
        this.paresDesfeitosProcesso = [];
        this.processarLote(0);
      },
      processarLote(cursor) {
        conciliacaoProjetoServico.processarProjetos(cursor, this.reprocessarTudo, this.todos)
          .then(dados => {
            this.processados += (dados && dados.conciliados) || 0;
            this.lancamentosLidos += (dados && dados.lancamentos) || 0;

            const desfeitos = (dados && dados.paresDesfeitos) || [];
            if (desfeitos.length > 0) this.paresDesfeitosProcesso = this.paresDesfeitosProcesso.concat(desfeitos).slice(0, 100);

            if (dados && !dados.concluido) {
              this.processarLote(dados.cursor);
              return;
            }

            this.processando = false;
            if (this.paresDesfeitosProcesso.length === 0) this.mostrarProcessamento = false;
            else toastr.warning(this.paresDesfeitosProcesso.length + ' aviso(s) de conciliação desfeita. Veja a lista na janela.');
            if (this.processados > 0) toastr.success(this.processados.toLocaleString('pt-BR') + ' lançamento(s) conciliados automaticamente nos projetos.');
            else toastr.info('Nenhum lançamento novo para conciliar automaticamente.');
            this.lista(this.pagina);
          })
          .catch(res => {
            this.processando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível processar a conciliação automática.');
            if (this.processados > 0) this.lista(this.pagina);
          });
      },
      exportar() {
        if (this.exportando) return;
        this.exportando = true;

        conciliacaoProjetoServico.exportarLista(this.montarFiltros(), this.todos)
          .then(dados => {
            this.exportando = false;
            const registros = (dados && dados.registros) || [];

            if (registros.length === 0) { toastr.info('Nenhum projeto para exportar com os filtros atuais.'); return; }

            this.gerarCsv(registros, dados.dataReferenciaTesourariaCurta || '');
          })
          .catch(() => { this.exportando = false; toastr.error('Não foi possível exportar a lista.'); });
      },
      gerarCsv(registros, ref) {
        const num = v => v == null ? '' : (+v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false });
        const cols = ['ID projeto', 'Projeto', 'Coordenador', 'Situação do projeto', 'Vigência início', 'Vigência fim',
          'Cor da vigência', 'Situação da vigência', 'Dias para o término',
          'Conta padrão', 'Projetos na conta padrão', 'Conciliado no Manager' + (ref ? ' em ' + ref : ''), 'Extrato (banco)', 'Data do saldo do banco', 'Diferença',
          'Status', 'Lançamentos', 'Conciliados', 'Pendências', 'Conclusão (%)', 'Última atualização', 'Usuário'];
        const esc = v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"';

        const linhas = [cols.map(esc).join(';')];

        registros.forEach(r => {
          const vig = this.vigencia(r);
          const t = r.tesouraria;
          const temBanco = this.temBanco(t);

          linhas.push([
            r.idProjeto, r.nomeProjeto, r.coordenador, r.encerrado ? 'Encerrado' : 'Ativo',
            r.vigenciaInicio, r.vigenciaFim, vig.cor, vig.situacao, vig.dias == null ? '' : vig.dias,
            r.nomeContaPadrao, r.idContaPadrao ? r.projetosNaConta : '',
            t ? num(t.saldoConciliado) : '', temBanco ? num(t.saldoBanco) : '', temBanco ? t.dataSaldoBancoTexto : '', temBanco ? num(t.divergencia) : '',
            this.situacao(r).label,
            r.totalLancamentos, r.lancamentosConciliados, this.pendencias(r), r.percentualConclusao,
            r.ultimaAtualizacao, r.usuarioUltimaAtualizacao
          ].map(esc).join(';'));
        });

        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'lista-conciliacao-projetos-' + moment().format('DD-MM-YYYY') + '.csv';
        link.click();
        URL.revokeObjectURL(url);

        toastr.success(registros.length.toLocaleString('pt-BR') + ' projeto(s) exportados.');
      },
      abrirConfiguracao() { this.mostrarConfiguracao = true; },
      fecharConfiguracao() { this.mostrarConfiguracao = false; },
      aoSalvarConfiguracao() {
        this.mostrarConfiguracao = false;
        this.lista(this.pagina);
      },
      corProgresso(p) { return p >= 100 ? '#1ab394' : (p >= 50 ? '#f8ac59' : '#ed5565'); },
      situacao(r) {
        if (r.conciliado) return { label: 'Conciliado', cls: 'badge-ok', icon: 'fa-check' };
        if ((r.lancamentosConciliados || 0) > 0) return { label: 'Em conciliação', cls: 'badge-andamento', icon: 'fa-refresh' };
        return { label: 'Não conciliado', cls: 'badge-no', icon: 'fa-clock-o' };
      },
      vigencia(r) {
        if (r.encerrado)
          return { cls: 'vig-neutro', cor: 'Cinza', situacao: 'Projeto encerrado', label: 'Projeto já encerrado', dias: null };

        const fim = r.vigenciaFim ? moment(r.vigenciaFim, 'DD/MM/YYYY') : null;

        if (!fim || !fim.isValid())
          return { cls: 'vig-ok', cor: 'Verde', situacao: 'Sem data de término', label: 'Sem data de término: não há prazo para encerrar', dias: null };

        const dias = fim.startOf('day').diff(moment().startOf('day'), 'days');

        if (dias < 0)
          return { cls: 'vig-vencida', cor: 'Vermelho', situacao: 'Vigência vencida', label: 'Vigência vencida há ' + Math.abs(dias) + ' dia(s) — o projeto deveria estar encerrado', dias };

        if (dias <= DIAS_ALERTA_VIGENCIA)
          return { cls: 'vig-perto', cor: 'Amarelo', situacao: 'Termina em breve', label: dias === 0 ? 'Vigência termina hoje' : 'Vigência termina em ' + dias + ' dia(s)', dias };

        return { cls: 'vig-ok', cor: 'Verde', situacao: 'Dentro da vigência', label: 'Dentro da vigência · faltam ' + dias + ' dia(s)', dias };
      },
      podeAbrir(r) { return !r.encerrado || (r.lancamentosConciliados || 0) > 0; },
      pendencias(r) { return Math.max(0, (r.totalLancamentos || 0) - (r.lancamentosConciliados || 0)); },
      iniciou(r) { return (r.lancamentosConciliados || 0) > 0; },
      numero(v) { return (v || 0).toLocaleString('pt-BR'); },
      relativo(d) {
        if (!d) return '';
        const dt = moment(d, 'DD/MM/YYYY');
        if (!dt.isValid()) return '';
        const dias = moment().startOf('day').diff(dt.clone().startOf('day'), 'days');
        if (dias < 0) return '';
        if (dias === 0) return 'Hoje';
        if (dias === 1) return 'Ontem';
        if (dias < 30) return 'há ' + dias + ' dias';
        return '';
      },
    },
    created() { this.lista(this.pagina); },
    watch: {
      'filtros.status'() { this.agendarLista(); },
      'filtros.situacaoProjeto'() { this.carregarProjetos(); this.agendarLista(); this.$nextTick(() => this.sincronizarSelectSituacaoVigencia()); },
      'filtros.idResponsavel'() { this.agendarLista(); },
      'filtros.vigenciaDe'() { this.agendarLista(); },
      'filtros.vigenciaAte'() { this.agendarLista(); },
      'filtros.situacaoVigencia'() { this.agendarLista(); this.$nextTick(() => this.sincronizarSelectSituacaoVigencia()); },
      'filtros.idProjeto'() { this.agendarLista(); this.$nextTick(() => this.sincronizarSelectProjeto()); },
      listaProjetos() { this.$nextTick(() => this.sincronizarSelectProjeto()); },
      filtros: { deep: true, handler() { this.salvarFiltros(); } },
    },
  }
</script>

<template>
  <div>
  <div class="lst-page">
  <div :class="['lst-card', {'animated': animated}, $root.animacaoPadrao]">

    <div class="lst-topo">

    <div class="lst-head">
      <div class="lst-head-esq">
      <div>
        <div class="lst-tit">Lista de Conciliação</div>
        <div class="lst-res">
          {{ resumo.totalConciliacoes }} {{ resumo.totalConciliacoes === 1 ? 'projeto' : 'projetos' }} ·
          {{ resumo.conciliadas }} {{ resumo.conciliadas === 1 ? 'conciliado' : 'conciliados' }}
          <span v-if="pendentes > 0">· <span class="pend">{{ pendentes }} {{ pendentes === 1 ? 'pendente' : 'pendentes' }}</span> </span>· {{ indice }}% concluído
        </div>
      </div>
        <span class="lst-sep"></span>
        <button type="button" class="btn btn-success lst-atualizar" :disabled="carregando" @click="atualizar" title="Recalcula os cards, a lista e os projetos da busca, mantendo os filtros">
          <i class="fa fa-refresh" :class="{ 'fa-spin': carregando }"></i> Atualizar
        </button>
        <span class="lst-atu-hora" v-if="ultimaAtualizacao">atualizado às {{ ultimaAtualizacao }}</span>
      </div>
      <label class="lst-chk" v-if="possuiRestricaoResponsavel">
        <input type="checkbox" :checked="todos" @change="alternarTodos"> Mostrar todos os projetos
      </label>
    </div>

    <div class="kpi-faixa">
      <button type="button" class="kpi-card kpi-todas" :class="{ ativo: filtros.status === '0' }" @click="filtrarStatus('0')">
        <div class="kpi-lbl">{{ tituloSituacao }}</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.totalConciliacoes }}</span> <span class="kpi-qlf">no filtro atual</span></div>
      </button>
      <button type="button" class="kpi-card kpi-ok" :class="{ ativo: filtros.status === '1' }" @click="filtrarStatus('1')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Conciliados</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.conciliadas }}</span> <span class="kpi-qlf">{{ pctConciliadas }}% do total</span></div>
      </button>
      <button type="button" class="kpi-card kpi-andamento" :class="{ ativo: filtros.status === '3' }" @click="filtrarStatus('3')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Em conciliação</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.emConciliacao }}</span> <span class="kpi-qlf">{{ pctEmConciliacao }}% do total</span></div>
      </button>
      <button type="button" class="kpi-card kpi-nunca" :class="{ ativo: filtros.status === '2' }" @click="filtrarStatus('2')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Não conciliados</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.naoConciliadas }}</span> <span class="kpi-qlf">{{ pctNaoConciliadas }}% do total</span></div>
      </button>
    </div>

    <div class="ibox">
      <div class="ibox-title flt-titulo"><h5><i class="fa fa-filter"></i> Filtros</h5>
        <div class="rec-faixa">
          <span class="rec-total" v-if="carregando">Exibindo <b>…</b></span>
          <span class="rec-total" v-else>Exibindo <b>{{ totalRegistros || 0 }}</b> {{ totalRegistros === 1 ? 'projeto' : 'projetos' }}</span>
          <div class="rec-chips">
            <button v-for="c in chipsRecorte" :key="c.chave" type="button" class="rec-chip" :class="c.classe" @click="c.remover" title="Clique para tirar este filtro">
              <i v-if="c.icone" class="fa" :class="c.icone" :style="c.cor ? { color: c.cor } : null"></i><span v-else-if="c.classe" class="rec-dot"></span>
              <span class="rec-rot">{{ c.rotulo }}</span>
              <i class="fa fa-times rec-x"></i>
            </button>
            <button v-if="temFiltro" type="button" class="rec-chip rec-chip-limpar" @click="limparFiltros">
              <i class="fa fa-eraser"></i> Limpar filtros
            </button>
          </div>
        </div>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <div class="form-group">
              <label class="control-label">Buscar Projeto</label>
              <select id="projetoFiltro" class="form-control" v-model="filtros.idProjeto" style="width:100%">
                <option value=""></option>
                <option :value="p.idProjetoCript" v-for="p in projetosOpcoes" :key="p.idProjetoCript">{{ p.nomeProjeto }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="form-group">
              <label class="control-label">Situação do projeto</label>
              <div class="seg-situacao">
                <button type="button" :class="{ ativo: filtros.situacaoProjeto === '0' }" @click="filtros.situacaoProjeto = '0'">Ativos</button>
                <button type="button" :class="{ ativo: filtros.situacaoProjeto === '1' }" @click="filtros.situacaoProjeto = '1'">Encerrados</button>
                <button type="button" :class="{ ativo: filtros.situacaoProjeto === '2' }" @click="filtros.situacaoProjeto = '2'">Todos</button>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="form-group">
              <label class="control-label">Responsável pelo projeto</label>
              <select class="form-control" v-model="filtros.idResponsavel">
                <option value="">Todos os responsáveis</option>
                <option :value="r.idUsuario" v-for="r in listaResponsaveis" :key="r.idUsuario">{{ r.nomeUsuario }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="form-group">
              <label class="control-label">Situação da vigência</label>
              <div class="f-sit-vig" :title="filtros.situacaoProjeto === '1' ? 'Projeto encerrado não tem situação de vigência (bolinha cinza)' : 'A cor da bolinha na coluna Vigência'">
                <select id="situacaoVigenciaFiltro" class="form-control" v-model="filtros.situacaoVigencia" :disabled="filtros.situacaoProjeto === '1'" style="width:100%">
                  <option value="0">Todas</option>
                  <option value="1">Verde · dentro da vigência</option>
                  <option value="2">Amarelo · termina em até 60 dias</option>
                  <option value="3">Vermelho · vigência vencida</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="form-group">
              <label class="control-label">Vigência do projeto</label>
              <div class="f-vigencia">
                <date-picker v-model="filtros.vigenciaDe" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="dd/mm/aaaa" :editable="false" :shortcuts="false" :clearable="true"></date-picker>
                <span class="f-vigencia-ate">até</span>
                <date-picker v-model="filtros.vigenciaAte" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="dd/mm/aaaa" :editable="false" :shortcuts="false" :clearable="true"></date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>

    <div class="ibox tabela-ibox lst-corpo" ref="corpo">
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-hover tabela-conc">
            <thead>
              <tr>
                <th>Projeto</th>
                <th title="Verde: dentro da vigência · Amarelo: termina em até 60 dias · Vermelho: vigência vencida, o projeto deveria estar encerrado">Vigência</th>
                <th class="text-right sep" :title="tituloSaldoTesouraria()">Saldo em {{ dataReferenciaTesouraria || 'D-1' }}</th>
                <th class="text-right" title="Último saldo lido no extrato do banco da conta padrão até a data de referência">Extrato em {{ dataReferenciaTesouraria || 'D-1' }}</th>
                <th class="text-right sep-r" title="Saldo do banco menos o conciliado no Manager na data do saldo do banco">Diferença</th>
                <th>Status</th>
                <th class="text-right">Pendências</th>
                <th style="min-width:200px">Conclusão</th>
                <th>Última atualização</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in registros" :key="r.idProjetoCript">
                <td class="col-projeto">
                  {{ r.nomeProjeto }} <span v-if="r.encerrado" class="tag-encerrada">encerrado</span>
                  <div class="conta-padrao" v-if="r.idContaPadrao">
                    <span class="mono" title="Conta padrão do projeto">{{ r.nomeContaPadrao }}</span>
                    <span v-if="r.contaPadraoEncerrada" class="tag-conta">encerrada</span>
                    <span v-if="r.projetosNaConta > 1" class="tag-conta tag-conta-comp"
                          :title="'A conta padrão é usada por ' + r.projetosNaConta + ' projetos: saldo, extrato e diferença são da conta inteira, não só deste projeto'">conta de {{ r.projetosNaConta }} projetos</span>
                  </div>
                  <div class="conta-padrao conta-sem" v-else>sem conta padrão</div>
                </td>
                <td class="small nowrap">
                  <template v-if="r.vigenciaInicio || r.vigenciaFim">
                    <div class="vig-linha" :title="vigencia(r).label">
                      <span class="vig-dot" :class="vigencia(r).cls"></span>
                      <span v-if="r.vigenciaInicio">{{ r.vigenciaInicio }}</span>
                      <span v-else class="vig-inf">∞</span>
                    </div>
                    <div class="text-muted vig-fim" :title="vigencia(r).label">
                      até <span v-if="r.vigenciaFim">{{ r.vigenciaFim }}</span>
                      <span v-else class="vig-inf">∞</span>
                    </div>
                  </template>
                  <span v-else class="text-muted"><em>Sem vigência</em></span>
                </td>
                <td class="text-right num sep" :title="r.tesouraria ? tituloSaldoTesouraria() : ''">
                  <template v-if="r.tesouraria">
                    <span :class="{ neg: r.tesouraria.saldoConciliado < 0 }">{{ moeda(r.tesouraria.saldoConciliado) }}</span>
                    <span class="sub">conciliado no Manager</span>
                    <span v-if="r.tesouraria.divergenciaOperacao" class="sub sub-op" :title="tituloOperacao(r.tesouraria)">
                      <i class="fa fa-exclamation-circle"></i> operação {{ moeda(r.tesouraria.saldoOperacao) }}
                    </span>
                  </template>
                  <span v-else class="mudo" :title="tituloSemSaldo(r)">—</span>
                </td>
                <td class="text-right num">
                  <template v-if="temBanco(r.tesouraria)">
                    <span :class="{ neg: r.tesouraria.saldoBanco < 0 }">{{ moeda(r.tesouraria.saldoBanco) }}</span>
                    <span class="sub">lido em {{ r.tesouraria.dataSaldoBancoTexto }}</span>
                  </template>
                  <template v-else-if="r.tesouraria">
                    <span class="mudo">—</span>
                    <span class="sub">sem saldo no extrato</span>
                  </template>
                  <span v-else class="mudo">—</span>
                </td>
                <td class="text-right num sep-r">
                  <span v-if="!temBanco(r.tesouraria)" class="mudo">—</span>
                  <span v-else-if="!r.tesouraria.divergente && !r.tesouraria.conciliacaoPendente" class="ok">R$ 0,00</span>
                  <span v-else class="div-cel" :title="tituloDivergencia(r.tesouraria)">
                    <span :class="r.tesouraria.conciliacaoPendente ? 'pend-val' : 'neg'">{{ moedaSinal(r.tesouraria.divergencia) }}</span>
                    <i class="fa" :class="[iconeDivergencia(r.tesouraria), corDivergencia(r.tesouraria)]"></i>
                  </span>
                </td>
                <td>
                  <span class="badge-status" :class="situacao(r).cls"><i class="fa" :class="situacao(r).icon"></i> {{ situacao(r).label }}</span>
                </td>
                <td class="text-right">
                  <template v-if="iniciou(r)">
                    <div class="pendencias" :class="{ 'pend-zero': pendencias(r) === 0 }">{{ numero(pendencias(r)) }}</div>
                    <small class="text-muted">{{ pendencias(r) === 1 ? 'item' : 'itens' }}</small>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <template v-if="iniciou(r)">
                    <div class="barra-conc">
                      <span :style="{ width: r.percentualConclusao + '%', background: corProgresso(r.percentualConclusao) }"></span>
                    </div>
                    <div class="barra-legenda">
                      <span class="dot" :style="{ background: corProgresso(r.percentualConclusao) }"></span>
                      <strong :style="{ color: corProgresso(r.percentualConclusao) }">{{ r.percentualConclusao }}%</strong>
                      <span class="text-muted">· {{ numero(r.lancamentosConciliados) }} / {{ numero(r.totalLancamentos) }} itens</span>
                    </div>
                  </template>
                  <span v-else class="text-muted"><em>Não iniciada</em></span>
                </td>
                <td class="nowrap">
                  <div>{{ r.ultimaAtualizacao || '---' }}<span class="text-muted" v-if="relativo(r.ultimaAtualizacao)"> · {{ relativo(r.ultimaAtualizacao) }}</span></div>
                  <small class="text-muted col-usuario" v-if="r.usuarioUltimaAtualizacao" :title="'Última alteração feita por ' + r.usuarioUltimaAtualizacao">
                    <i class="fa fa-user-o"></i> {{ r.usuarioUltimaAtualizacao }}
                  </small>
                </td>
                <td class="text-right">
                  <button v-if="podeAbrir(r)" type="button" class="btn btn-abrir" :class="r.encerrado ? 'btn-white btn-consulta' : 'btn-primary'"
                          :title="r.encerrado ? 'Projeto encerrado: a conciliação abre apenas para consulta' : ''" @click="abrirConciliacao(r)">
                    {{ r.encerrado ? 'Ver conciliação' : 'Abrir conciliação' }} <i class="fa fa-arrow-right"></i>
                  </button>
                  <span v-else class="text-muted small">Encerrado, sem conciliação</span>
                </td>
              </tr>
              <tr v-show="carregando"><td colspan="10" class="text-center text-muted" style="padding:24px"><i class="fa fa-spinner fa-pulse fa-2x"></i><div class="m-t-xs">Carregando...</div></td></tr>
              <tr v-show="!carregando && registros.length === 0"><td colspan="10" class="text-center text-muted" style="padding:24px">Nenhum projeto encontrado.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="acoes-rodape">
      <div class="acoes-rodape-l">
        <button v-if="podeConfigurar" type="button" class="btn btn-white" @click="abrirConfiguracao"><i class="fa fa-cog"></i> Configurações</button>
      </div>
      <div class="acoes-rodape-c">
        <div class="pag" v-if="totalRegistros > 0">
          <button v-if="totalPaginas > 1" type="button" :disabled="pagina <= 1" aria-label="Anterior" @click="irPagina(pagina - 1)"><i class="fa fa-angle-left"></i></button>
          <button v-for="p in paginas" :key="'p' + p" type="button" :class="{ ativo: p === pagina }" @click="irPagina(p)">{{ p }}</button>
          <button v-if="totalPaginas > 1" type="button" :disabled="pagina >= totalPaginas" aria-label="Próxima" @click="irPagina(pagina + 1)"><i class="fa fa-angle-right"></i></button>
        </div>
        <span class="pag-info">{{ infoPaginacao }}</span>
      </div>
      <div class="acoes-rodape-r">
        <button type="button" class="btn btn-white" :disabled="exportando || carregando" @click="exportar"
                title="Exporta todos os projetos da lista com os filtros atuais, não só a página exibida">
          <i class="fa" :class="exportando ? 'fa-spinner fa-pulse' : 'fa-table'"></i> {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
        </button>
        <button v-if="podeAlterar" type="button" class="btn btn-primary" :disabled="processando" @click="abrirProcessamento"
                title="Aproveita as conciliações já feitas no banco e concilia automaticamente os lançamentos de todos os projetos">
          <i class="fa" :class="processando ? 'fa-spinner fa-pulse' : 'fa-magic'"></i>
          {{ processando ? 'Processando...' : 'Processar todos os projetos' }}
        </button>
      </div>
    </div>

  </div>
  </div>

    <configuracao-projeto-modal v-if="mostrarConfiguracao" @fechar="fecharConfiguracao" @salvo="aoSalvarConfiguracao"></configuracao-projeto-modal>

    <div v-if="mostrarProcessamento" class="conc-ov">
      <div class="conc-modal proc-modal">
        <div class="proc-head">
          <h4>Processar conciliação de todos os projetos</h4>
          <small class="proc-sub">Aproveita o que já foi conciliado no banco: cada lançamento conferido cujos rateios do projeto fecham com o valor é conciliado automaticamente.</small>
        </div>

        <div class="proc-corpo">
          <div v-if="carregandoPrevia" class="proc-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
          <template v-else>
            <div class="proc-cards">
              <div class="proc-card">
                <div class="proc-lbl">Lançamentos a verificar</div>
                <div class="proc-num">{{ numero(previa.pendentes) }}</div>
                <div class="proc-obs">{{ previa.incremental ? 'só o que entrou desde o último processamento' : 'todo o histórico dentro do período' }}</div>
              </div>
              <div class="proc-card">
                <div class="proc-lbl">Período considerado</div>
                <div class="proc-txt">{{ dataCorteTexto() }}</div>
                <div class="proc-obs" v-if="previa.restrito">só os projetos em que você é responsável</div>
                <div class="proc-obs" v-else-if="todos">todos os projetos, incluindo os de outros responsáveis</div>
              </div>
            </div>

            <label class="proc-check" v-if="previa.incremental || reprocessarTudo">
              <input type="checkbox" :checked="reprocessarTudo" :disabled="processando" @change="alternarReprocessar">
              Reverificar todo o histórico (mais demorado; use quando houver baixas antigas feitas no Desktop)
            </label>

            <div v-if="!previa.dataCorte && previa.pendentes > 0" class="proc-alerta">
              Sem data de corte, o processamento vai percorrer todo o histórico de uma vez.
              Se a intenção é começar de um período, feche esta janela e defina a data de corte em Configurações.
            </div>

            <div v-if="processando" class="proc-progresso">
              <i class="fa fa-spinner fa-pulse"></i>
              {{ numero(processados) }} lançamento(s) conciliados ·
              {{ numero(lancamentosLidos) }} de {{ numero(previa.pendentes) }} verificados. Deixe esta janela aberta.
            </div>

            <div v-if="paresDesfeitosProcesso.length > 0" class="proc-avisos proc-desfeitos">
              <div class="proc-avisos-tit">Conciliações desfeitas porque foram alteradas fora do módulo</div>
              <ul>
                <li v-for="(a, i) in paresDesfeitosProcesso" :key="i">{{ a }}</li>
              </ul>
            </div>
          </template>
        </div>

        <div class="proc-foot">
          <button type="button" class="btn btn-primary" :disabled="processando || carregandoPrevia" @click="processarProjetos">
            <i class="fa" :class="processando ? 'fa-spinner fa-pulse' : 'fa-magic'"></i> {{ processando ? 'Processando...' : 'Processar' }}
          </button>
          <button type="button" class="btn btn-sair" :disabled="processando" @click="fecharProcessamento"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
  .proc-avisos { margin-top: 12px; border: 1px solid #f0d9a8; background: #fffdf7; border-radius: 7px; padding: 10px 13px; max-height: 220px; overflow-y: auto; }
  .proc-desfeitos { border-color: #e6b8b2; background: #fff8f7; }
  .proc-desfeitos .proc-avisos-tit { color: #9b3428; }
  .proc-avisos-tit { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; color: #8a5a00; }
  .proc-avisos ul { margin: 6px 0 0; padding-left: 18px; }
  .proc-avisos li { font-size: 12.5px; color: #4a545e; margin-bottom: 3px; }
  .kpi-faixa { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; padding: 12px 16px; }
  .kpi-card {
    text-align: left; padding: 10px 13px; background: #fff; border: 1px solid #e6e9ed; border-radius: 7px;
    transition: border-color .12s, background .12s;
  }
  .kpi-card:hover { border-color: #c6ccd4; }
  .kpi-lbl { display: flex; align-items: center; gap: 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .kpi-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
  .kpi-val { margin-top: 4px; }
  .kpi-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; font-size: 21px; font-weight: 600; color: #1c2024; }
  .kpi-qlf { font-size: 11.5px; color: #8a939c; margin-left: 5px; }

  .kpi-ok .kpi-lbl, .kpi-ok .kpi-num { color: #0a6d4d; }
  .kpi-andamento .kpi-lbl, .kpi-andamento .kpi-num { color: #c98a00; }
  .kpi-nunca .kpi-lbl, .kpi-nunca .kpi-num { color: #a13c3c; }

  .kpi-card.ativo { border-color: #a9b2bb; background: #f7f9fa; box-shadow: inset 0 0 0 1px #a9b2bb; }
  .kpi-ok.ativo { border-color: #0f8a5f; background: #f4faf7; box-shadow: inset 0 0 0 1px #0f8a5f; }
  .kpi-andamento.ativo { border-color: #c98a00; background: #fdf9ef; box-shadow: inset 0 0 0 1px #c98a00; }
  .kpi-nunca.ativo { border-color: #c98080; background: #fdf7f7; box-shadow: inset 0 0 0 1px #c98080; }

  .lst-page { box-sizing: border-box; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: #eceef1; padding: 12px 14px; overflow: auto; }
  .lst-card { min-width: 1280px; height: 100%; display: flex; flex-direction: column; background: #fff; border: 1px solid #d3d8de; border-radius: 8px; box-shadow: 0 1px 2px rgba(16,24,40,.06); overflow: hidden; }
  .lst-topo { flex: 0 0 auto; padding: 0 0 0; }
  .lst-head-esq { display: flex; align-items: center; gap: 12px; }
  .lst-sep { align-self: stretch; width: 1px; background: #dfe3e8; margin: 2px 4px; }
  .lst-atualizar { height: 34px; padding: 0 14px; font-size: 13px; font-weight: 600; }
  .lst-atu-hora { font-size: 11.5px; color: #8a939c; }
  .flt-titulo { display: flex; align-items: center; gap: 14px; min-height: 48px; }
  .flt-titulo h5 { float: none; margin: 0; white-space: nowrap; }
  .rec-faixa { display: flex; align-items: center; gap: 12px; flex: 1 1 auto; min-width: 0; padding-left: 14px; border-left: 1px solid #e6e9ed; }
  .rec-total { font-size: 12px; color: #6b747e; white-space: nowrap; }
  .rec-total b { font-family: 'IBM Plex Mono', Consolas, monospace; color: #1c2024; }
  .rec-chips { display: flex; flex-wrap: wrap; gap: 6px; flex: 1 1 auto; }
  .rec-chip { display: inline-flex; align-items: center; gap: 6px; height: 28px; padding: 0 10px; border: 1px solid #b7dcc9; border-radius: 14px; background: #e8f5ef; color: #0a6d4d; font-size: 12px; font-weight: 600; max-width: 360px; transition: background .12s, border-color .12s, color .12s; }
  .rec-rot { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rec-x { font-size: 11px; opacity: .55; }
  .rec-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
  .rec-chip .fa-circle { font-size: 9px; }
  .rec-ok { background: #f4faf7; border-color: #9fd3bd; color: #0a6d4d; }
  .rec-andamento { background: #fdf9ef; border-color: #e6cd8f; color: #9a6a00; }
  .rec-nunca { background: #fdf7f7; border-color: #e3bcbc; color: #a13c3c; }
  .rec-chip:not(.rec-chip-limpar):hover { background: #fdf2f2 !important; border-color: #e3a5a5 !important; color: #a13c3c !important; }
  .rec-chip:not(.rec-chip-limpar):hover .rec-x { opacity: 1; }
  .rec-chip-limpar { border: 1px dashed #b9c3cd; background: #fff; color: #5b6570; }
  .rec-chip-limpar:hover { background: #f1f5f9; border-color: #8a939c; }
  .kpi-card.ativo { position: relative; }
  .kpi-card.ativo::after { content: ''; position: absolute; left: 50%; bottom: -7px; margin-left: -6px; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #a9b2bb; }
  .kpi-ok.ativo::after { border-top-color: #0f8a5f; }
  .kpi-andamento.ativo::after { border-top-color: #c98a00; }
  .kpi-nunca.ativo::after { border-top-color: #c98080; }
  .lst-head { display: flex; justify-content: space-between; align-items: flex-start; padding: 11px 16px 9px; border-bottom: 1px solid #eef1f4; }
  .lst-tit { font-size: 13.5px; font-weight: 600; color: #1c2024; }
  .lst-res { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 12px; color: #6b747e; margin-top: 2px; }
  .lst-res .pend { color: #c98a00; }
  .lst-chk { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: normal; color: #3b444d; margin: 0; cursor: pointer; padding: 5px 10px; border: 1px solid #dfe3e8; border-radius: 5px; }
  .lst-chk input { width: 13px; height: 13px; margin: 0; }
  .lst-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; margin: 0; border: none; box-shadow: none; }
  .lst-topo .ibox { border: none; box-shadow: none; margin-bottom: 10px; }
  .lst-corpo .ibox-content { border: none; padding-top: 0; }

  .acoes-rodape {
    flex: 0 0 auto; display: grid; grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr); align-items: center; gap: 12px;
    padding: 12px 14px; background: #f7f9fa; border-top: 1px solid #dfe3e8;
  }
  .acoes-rodape-l { display: flex; align-items: center; gap: 8px; }
  .acoes-rodape-r { display: flex; align-items: center; justify-content: flex-end; gap: 8px; }
  .acoes-rodape-c { display: flex; flex-direction: column; align-items: center; gap: 4px; min-width: 0; }
  .pag { display: inline-flex; align-items: center; gap: 2px; }
  .pag button { min-width: 30px; height: 30px; padding: 0 9px; border: 1px solid #dfe3e8; background: #fff; color: #5b6570; font-size: 12.5px; cursor: pointer; }
  .pag button.ativo { background: #1ab394; border-color: #1ab394; color: #fff; font-weight: 600; }
  .pag button[disabled] { color: #c7cdd4; cursor: default; }
  .pag-info { font-size: 11.5px; color: #8a939c; }

  .tabela-ibox { margin-top: -16px; }
  .tabela-conc { margin-bottom: 0; }
  .tabela-conc thead th {
    position: sticky; top: 0; z-index: 2;
    background: #f7f9fa; color: #7b848e; font-weight: 600; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em;
    border-bottom: 1px solid #dfe3e8 !important; border-top: none; padding: 8px 9px; white-space: nowrap;
  }
  .tabela-conc tbody td { vertical-align: middle; padding: 9px 8px; border-top: 1px solid #f0f1f3; }
  .tabela-conc tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .tabela-conc tbody tr:hover > td { background: #eaf5ff !important; }
  .tabela-conc .nowrap { white-space: nowrap; }
  .tabela-conc .col-projeto { font-weight: 600; color: #1a2035; }
  .tabela-conc .col-usuario { display: inline-block; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; }

  .f-vigencia { display: flex; align-items: center; gap: 8px; }
  .f-vigencia-ate { flex: 0 0 auto; font-size: 12.5px; color: #8a939c; }
  .vig-inf { font-size: 14px; line-height: 1; color: #9aa3ac; vertical-align: -1px; }
  .vig-linha { display: flex; align-items: center; gap: 6px; }
  .vig-fim { padding-left: 14px; }
  .vig-dot { flex: 0 0 auto; width: 8px; height: 8px; border-radius: 50%; }
  .vig-ok { background: #18a689; }
  .vig-perto { background: #f8ac59; }
  .vig-vencida { background: #ed5565; }
  .vig-neutro { background: #c6ccd4; }
  .vig-todas { background: linear-gradient(90deg, #18a689 33%, #f8ac59 33%, #f8ac59 66%, #ed5565 66%); }

  .seg-situacao { display: flex; width: 100%; border: 1px solid #c7cdd4; border-radius: 5px; overflow: hidden; height: 34px; }
  .seg-situacao button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 13px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .seg-situacao button:first-child { border-left: none; }
  .seg-situacao button:hover { background: #f4f6f8; }
  .seg-situacao button.ativo { background: #1ab394; color: #fff; font-weight: 600; }

  .badge-status { display: inline-flex; align-items: center; gap: 6px; padding: 6px 13px; border-radius: 14px; font-size: 12px; font-weight: 600; line-height: 1; }
  .badge-ok { background: #e5f7f0; color: #18a689; }
  .badge-andamento { background: #fff4e0; color: #d68a00; }
  .badge-no { background: #fdecec; color: #e05a5a; }

  .pendencias { font-size: 16px; font-weight: 700; color: #34495e; line-height: 1.1; }
  .pendencias.pend-zero { color: #b3b9c0; font-weight: 500; }

  .barra-conc { height: 14px; border-radius: 7px; background: #eceef1; overflow: hidden; }
  .barra-conc > span { display: block; height: 100%; border-radius: 7px; transition: width .3s; }
  .barra-legenda { margin-top: 5px; font-size: 12px; }
  .barra-legenda .dot { display: inline-block; width: 9px; height: 9px; border-radius: 50%; margin-right: 5px; vertical-align: middle; }
  .barra-legenda strong { font-size: 13px; }

  .conc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.52); z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 22px; }
  .conc-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); }
  .proc-modal { width: 620px; max-width: 100%; display: flex; flex-direction: column; overflow: hidden; }
  .proc-head { padding: 16px 20px; border-bottom: 1px solid #e6e9ed; }
  .proc-head h4 { margin: 0; font-size: 15.5px; font-weight: 600; color: #1c2024; }
  .proc-sub { display: block; font-size: 12.5px; color: #6b747e; margin-top: 4px; line-height: 1.5; }
  .proc-corpo { padding: 18px 20px; min-height: 140px; }
  .proc-carregando { text-align: center; color: #8a939c; padding: 30px 0; }
  .proc-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .proc-card { padding: 12px 14px; border: 1px solid #e6e9ed; border-radius: 7px; background: #fbfcfd; }
  .proc-lbl { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .proc-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 24px; font-weight: 600; color: #1c2024; margin-top: 4px; }
  .proc-txt { font-size: 13px; color: #3b444d; margin-top: 8px; }
  .proc-obs { font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .proc-check { display: flex; align-items: flex-start; gap: 8px; margin-top: 14px; font-size: 12.5px; font-weight: normal; color: #3b444d; cursor: pointer; }
  .proc-check input { margin: 2px 0 0; }
  .proc-alerta { margin-top: 14px; background: #fff8e6; border: 1px solid #f0dfae; border-radius: 5px; padding: 10px 12px; font-size: 12.5px; color: #8a6d1f; line-height: 1.5; }
  .proc-progresso { margin-top: 14px; font-size: 12.5px; color: #0a6d4d; background: #f4faf7; border: 1px solid #cbe9dc; border-radius: 5px; padding: 10px 12px; }
  .proc-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 13px 20px; background: #fafbfc; border-top: 1px solid #e6e9ed; }
  .btn-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .btn-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }

  .tag-encerrada { display: inline-block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: #c0392b; background: #fdecec; border: 1px solid #f5c6c6; border-radius: 10px; padding: 1px 8px; margin-left: 6px; vertical-align: middle; }


  .conta-padrao { margin-top: 3px; font-weight: 400; display: flex; align-items: center; flex-wrap: wrap; gap: 5px; }
  .conta-padrao .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 11.5px; color: #34495e; }
  .conta-sem { font-size: 11.5px; color: #b3b9c0; font-style: italic; }
  .tag-conta { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: #c0392b; background: #fdecec; border: 1px solid #f5c6c6; border-radius: 10px; padding: 0 7px; line-height: 15px; }
  .tag-conta-comp { color: #5b3a9e; background: #f3effb; border-color: #dcd0f2; cursor: help; }

  .tabela-conc .sep { border-left: 1px solid #e6e9ed; }
  .tabela-conc .sep-r { border-right: 1px solid #e6e9ed; }
  .tabela-conc .num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; white-space: nowrap; font-size: 13px; color: #1a2035; }
  .tabela-conc .num .sub { display: block; font-family: 'Open Sans', sans-serif; font-size: 11px; color: #8a939c; margin-top: 2px; white-space: nowrap; font-weight: 400; }
  .tabela-conc .num .ok { color: #0a6d4d; }
  .tabela-conc .num .neg { color: #c0392b; font-weight: 600; }
  .tabela-conc .num .pend-val { color: #b06a15; font-weight: 600; }
  .tabela-conc .num .sub.sub-op { color: #b06a15; font-weight: 600; cursor: help; }
  .tabela-conc .num .mudo { color: #b3b9c0; }
  .tabela-conc .num .div-cel { display: inline-flex; align-items: center; justify-content: flex-end; gap: 5px; }
  .tabela-conc .num .div-vermelho { color: #c0392b; }
  .tabela-conc .num .div-laranja { color: #d68a00; }
  .tabela-conc .num .div-roxo { color: #5b3a9e; }

  .btn-abrir { height: 30px; padding: 0 12px; font-size: 12.5px; font-weight: 600; border-radius: 4px; }
  .btn-consulta { color: #5b6570; border-color: #c6ccd4; }

  .btn-abrir .fa { margin-left: 4px; transition: transform .15s; }
  .btn-abrir:hover .fa { transform: translateX(3px); }
</style>

<style>
  .lst-card .f-vigencia .mx-datepicker { flex: 1 1 0; min-width: 0; width: auto !important; }
  .lst-card .f-vigencia .mx-datepicker .mx-input-wrapper, .lst-card .f-vigencia .mx-datepicker input { width: 100%; }
  .lst-card .f-vigencia .mx-datepicker input { height: 34px; padding-right: 30px; }
  .sit-vig-op { display: inline-flex; align-items: center; gap: 8px; }
  .sit-vig-op .sit-vig-dot { flex: 0 0 auto; width: 8px; height: 8px; border-radius: 50%; }
  .sit-vig-op .sit-vig-ok { background: #18a689; }
  .sit-vig-op .sit-vig-perto { background: #f8ac59; }
  .sit-vig-op .sit-vig-vencida { background: #ed5565; }
  .sit-vig-op .sit-vig-neutro { background: #c6ccd4; }
  .sit-vig-op .sit-vig-todas { background: linear-gradient(90deg, #18a689 33%, #f8ac59 33%, #f8ac59 66%, #ed5565 66%); }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ConciliacaoLista.vue